// Aree e categorie per l'editor permessi utenti (rispecchia la sidebar).
// Ogni categoria è mappata a una "section" del backend (permessi granulari).
export const PERM_AREAS = [
  {
    key: "supervisore", area: "Area Supervisore",
    items: [
      { section: "supervisor_richiami", label: "Report operatori" },
      { section: "richiami_operatori", label: "Richiami operatori (segnala dal Report del giorno)" },
      { section: "disciplina_tabella", label: "Tabella segnalazioni operatori (lettere, PDF, email)" },
    ],
  },
  {
    key: "tecnica", area: "Area tecnica",
    items: [
      { section: "dashboard", label: "Dashboard" },
      { section: "dashboard_modifica", label: "Modifica dashboard (sposta, riordina, nascondi box)" },
      { section: "presenze", label: "Presenze" },
      { section: "consegne", label: "Consegne" },
      { section: "riunioni", label: "Riunioni" },
      { section: "consegne_archivio", label: "Consegne: elimina + archivio" },
      { section: "turni", label: "Turni" },
      { section: "turni_modifica", label: "Turni: modifica (senza questo, sola lettura)" },
      { section: "attivita", label: "Prese visione / Attività" },
      { section: "news", label: "News e Task" },
      { section: "comunicazioni", label: "Comunicazioni" },
      { section: "email_massiva", label: "Email massiva (ospiti/operatori)" },
      { section: "menu", label: "Menù settimanale" },
      { section: "numeri_utili", label: "Numeri utili" },
    ],
  },
  {
    key: "operativa", area: "Area operativa",
    items: [
      { section: "supervisor_ospiti", label: "Report del giorno" },
      { section: "ospiti", label: "Ospiti (schede + Entrate/Uscite)" },
      { section: "blocco_posto", label: "Blocco posto (colonna spunta)" },
      { section: "registro", label: "Registro ospiti (colonna spunta)" },
      { section: "checkin", label: "Check-in Ospite" },
      { section: "alvo", label: "Alvo intestinale" },
      { section: "alzate", label: "Alzate" },
      { section: "messa_a_letto", label: "Messa a letto" },
      { section: "terapie", label: "Terapie" },
      { section: "controllo_terapie", label: "Controllo terapie" },
      { section: "non_mangia", label: "Non mangia" },
      { section: "non_beve", label: "Non beve" },
      { section: "piano_lavoro", label: "Piano di Lavoro OSS" },
      { section: "pulizie", label: "Pulizie" },
      { section: "pulizie_controllo", label: "Pulizie: controllo e verifica task" },
      { section: "pannoloni", label: "Pannoloni e presidi" },
      { section: "docce", label: "Docce" },
      { section: "infettive", label: "Eventi sanitari e Check-list sanitaria" },
      { section: "visite_mediche", label: "Visite mediche (prenotare visite, esiti, ricette)" },
      { section: "impostazione_terapie", label: "Impostazione terapie (vedere la categoria)" },
      { section: "terapie_modifica", label: "Modifica terapie da Impostazione terapie" },
      { section: "correzioni_definitive", label: "Correggi terapie ed esiti visite dopo il tempo di correzione (definitivi)" },
      { section: "parametri", label: "Parametri vitali" },
      { section: "cadute", label: "Cadute e infortuni" },
      { section: "correggi_spunte", label: "Correggi/annulla spunte già registrate da altri" },
    ],
  },
  {
    key: "utenti", area: "Area operatori",
    items: [
      { section: "operatori", label: "Operatori" },
      { section: "utenti", label: "Utenti e permessi" },
    ],
  },
  {
    key: "ingressi", area: "Area Ingressi",
    items: [
      { section: "ingressi_contatti", label: "Nuovi Contatti" },
      { section: "ingressi_report", label: "Report Ammissioni" },
      { section: "ingressi_registro", label: "Registro (registrati per struttura)" },
      { section: "prenotazioni", label: "Prenotazioni / Caparre" },
    ],
  },
  {
    key: "amministrazione", area: "Amministrazione",
    items: [
      { section: "rette", label: "Ricavi e rette" },
      { section: "spese", label: "Varie, Vitto e Affitto" },
      { section: "utenze", label: "Utenze" },
      { section: "buste_paga", label: "Buste paga, TFR e F24" },
      { section: "doc_admin", label: "Documenti amministrativi" },
      { section: "controllo", label: "Dashboard di gestione" },
      { section: "dash_amm_ospiti", label: "Vista Smart: Amministrazione ospiti (documenti, terapie, ricette, visite)" },
      { section: "dash_amm_operatori", label: "Vista Smart: Amministrazione operatori (buste paga, contratti)" },
      { section: "finanziario", label: "Finanziario (mutui, soci, ammortamenti, imposte)" },
      { section: "convenzione", label: "Convenzione (scheda ospite)" },
    ],
  },
  {
    key: "extra", area: "Extra",
    items: [
      { section: "extra", label: "Extra (entrate/uscite)" },
    ],
  },
  {
    key: "configurazione", area: "Configurazione",
    items: [
      { section: "strutture", label: "Strutture" },
      { section: "documenti", label: "Documenti e scadenze" },
      { section: "notifiche", label: "Notifiche" },
      { section: "audit", label: "Audit log" },
    ],
  },
];

// Sezioni dell'area Amministrazione: se un operatore le sblocca via PIN serve un PIN a 4 cifre
export const ADMIN_AREA_SECTIONS = ["rette", "spese", "utenze", "buste_paga", "doc_admin", "controllo"];
